import ajaxRequest from 'utils/_ajax-request.js'
import {loadingWindowVisible, loadingWindowHidden, loadingWindowHandler} from '4-component/loading/_index.js'
import { convertDateToUTC, convertDateObject } from 'utils/_convert_date.js'

export default (

) => {


  if (window.jQuery) {
    $(document).ready(function(){

      const customerSelect = $('#customer-select-add')
      if( customerSelect.length ) {
        const customerSelectValue = customerSelect.data('value')
        customerSelect.select2({
          data: [],
          width: '100%',
        });

        ajaxRequest(
          (xhr, error) => {
            if( error ) {
              return false
            }
            const data = JSON.parse(xhr.response)
            customerSelect.select2('destroy').empty().select2({data: data.results, width: '100%',});
            if( customerSelectValue ) {
              customerSelect.val(customerSelectValue)
            }
            else {
              customerSelect.val("")
            }
            customerSelect.trigger("change");
          },
          (customerSelect.data('source-data-url'))
        )
      }

    })
  }


  const periodFromElement = document.getElementById('invoice_add_period_from')
  const periodToElement = document.getElementById('invoice_add_period_to')

  if( window.flatpickr ) {
    if( periodFromElement ) {
      flatpickr(periodFromElement, {
        //defaultDate: (new Date( parseInt(periodFromElement.dataset.unixTimestamp, 10) * 1000)),
        defaultDate: convertDateObject(parseInt(periodFromElement.dataset.unixTimestamp, 10)),
        enableTime: false,
        enableSeconds: false,
        time_24hr: true,
        minuteIncrement: 1,
        dateFormat: 'Y-m-d',
        locale: 'ru',
      });
    }

    if( periodToElement ) {
      flatpickr(periodToElement, {
        //defaultDate: (new Date( parseInt(periodToElement.dataset.unixTimestamp, 10) * 1000)),
        defaultDate: convertDateObject(parseInt(periodToElement.dataset.unixTimestamp, 10)),
        enableTime: false,
        enableSeconds: false,
        time_24hr: true,
        minuteIncrement: 1,
        dateFormat: 'Y-m-d',
        locale: 'ru',
      });
    }
  }

  const invoiceSaveBtn = document.getElementById('invoice_add_save')
  if( invoiceSaveBtn ) {
    invoiceSaveBtn.addEventListener('click', (event) => {
      if( periodFromElement && periodFromElement._flatpickr.latestSelectedDateObj ) {
        const periodFromElementHidden = document.querySelector('.section-admin-invoice-new__period input[name="invoice_filters[period_from]"]')
        if( periodFromElementHidden ) {
          //periodFromElementHidden.value = Math.floor(periodFromElement._flatpickr.latestSelectedDateObj.getTime() / 1000)
          periodFromElementHidden.value = convertDateToUTC(Math.floor(periodFromElement._flatpickr.latestSelectedDateObj.getTime() / 1000))
        }
        //periodFromElement.value = Math.floor(periodFromElement._flatpickr.latestSelectedDateObj.getTime() / 1000)
      }
      if( periodToElement && periodToElement._flatpickr.latestSelectedDateObj ) {
        const periodToElementHidden = document.querySelector('.section-admin-invoice-new__period input[name="invoice_filters[period_to]"]')
        if( periodToElementHidden ) {
          //periodToElementHidden.value = Math.floor(periodToElement._flatpickr.latestSelectedDateObj.getTime() / 1000)
          periodToElementHidden.value = convertDateToUTC(Math.floor(periodToElement._flatpickr.latestSelectedDateObj.getTime() / 1000))
        }
        //periodToElement.value = Math.floor(periodToElement._flatpickr.latestSelectedDateObj.getTime() / 1000)
      }
    })
  }

  loadingWindowHandler('.page__content')


  const billTaskRefreshStatus = () => {
    ajaxRequest(
      (xhr, error) => {
        if( error ) {
          return false
        }
        const data = JSON.parse(xhr.response)
        console.log(data)

        if( data.id > 0 ) {
          document.getElementById('bill-task-status').innerHTML = data.status_name
          document.getElementById('bill-task-running').innerHTML = data.progress.in_process
          document.getElementById('bill-task-done').innerHTML = data.progress.finished
        }
        else {
          if( billTaskInterval ) {
            clearInterval(billTaskInterval)
          }

          if( billTaskElement ) {
            billTaskElement.style.display = 'none'
          }


          const windowText = document.querySelector('#order_loading_success .loading__text')
          if( windowText ) {
            windowText.innerHTML = 'Выставлено счетов: ' + data.progress.finished
          }

          loadingWindowVisible('success', '.page__content')

          const buttonSuccess = document.querySelector('.page__content .loading__button--success')
          if( buttonSuccess ) {
            buttonSuccess.addEventListener('click', (event) => {
              window.location.reload()
            })
          }
        }

      },
      ('/ru/admin/invoices/bill-task-refresh-status?ajax=1'),
      {},
      'POST'
    )
  }

  const billTaskExecute = () => {
    ajaxRequest(
      (xhr, error) => {
        if( error ) {
          return false
        }
        const data = JSON.parse(xhr.response)
        console.log(data)

        if( data.id > 0 ) {
          document.getElementById('bill-task-status').innerHTML = data.status_name
          document.getElementById('bill-task-running').innerHTML = data.progress.in_process
          document.getElementById('bill-task-done').innerHTML = data.progress.finished
        }
        else {
          if( billTaskExecuteInterval ) {
            clearInterval(billTaskExecuteInterval)
          }

          if( billTaskElement ) {
            billTaskElement.style.display = 'none'
          }

          //window.location.reload()

          const windowText = document.querySelector('#order_loading_success .loading__text')
          if( windowText ) {
            windowText.innerHTML = 'Выставлено счетов: ' + data.progress.finished
          }

          loadingWindowVisible('success', '.page__content')

          const buttonSuccess = document.querySelector('.page__content .loading__button--success')
          if( buttonSuccess ) {
            buttonSuccess.addEventListener('click', (event) => {
              window.location.reload()
            })
          }

        }
      },
      ('/ru/admin/invoices/bill-task-execute?ajax=1'),
      {},
      'POST'
    )
  }

  const billTaskElement = document.getElementById('bill-task')

  let billTaskInterval = undefined
  if( billTaskElement ) {
    billTaskInterval = setInterval(function(){billTaskRefreshStatus()}, 30000)
  }

  /*let billTaskExecuteInterval = undefined
  if( billTaskElement ) {
    billTaskExecuteInterval = setInterval(function(){billTaskExecute()}, 120000)
  }*/

  const billTaskRefreshStatusBtn = document.getElementById('bill-task-refresh-status')
  if( billTaskRefreshStatusBtn ) {
    billTaskRefreshStatusBtn.addEventListener('click', (event) => {
      event.preventDefault();
      billTaskRefreshStatus();
    })
  }

  const billTaskCancelBtn = document.getElementById('bill-task-cancel')
  if( billTaskCancelBtn ) {
    billTaskCancelBtn.addEventListener('click', (event) => {
      event.preventDefault();
      ajaxRequest(
        (xhr, error) => {
          window.location.reload()
        },
        ('/ru/admin/invoices/bill-task-cancel?ajax=1'),
        {},
        'POST'
      )
    })
  }

}

